import coolguy from "../images/me.jpeg";
import TextType from "../components/TypeText";
import { FaFileDownload, FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";

// Replace 'YOUR_FILE_ID' with your actual Google Drive file ID
const RESUME_URL = "https://drive.google.com/uc?export=download&id=1R8DDgyD6by-DU20XB4HIOVfEhq_ck17T";

const HeroSection = ()=>{
    // const [isMenuOpen , setIsMenuOpen] = useState(false); 
    
    return(
        <div className="w-full flex flex-col flex-1 gap-5 p-2 px-10
                        lg:flex-row lg:p-20 lg:gap-20
                        justify-center items-center">
            <img src={coolguy} alt="" className="h-52 lg:h-96 rounded-full"/>

            <div className="flex flex-col gap-3 p-5">
                <div className="text-2xl lg:text-4xl font-roboto h-[60px]">
                    <TextType
                        text={["Hello, this is Tulasidhar", "This is a brief about me."]}
                        typingSpeed={50}
                        pauseDuration={2000}
                        showCursor={true}
                        cursorCharacter="|"
                    />
                    <br/>
                </div>
                
                <br/>
                
                <p className="text-sm sm:text-xl/9">
                    I am a Computer Science 2025 undergraduate and a seasoned <strong>Full Stack Developer</strong> with extensive experience in <strong>React</strong> and <strong>Spring Boot</strong>. I specialize in architecting scalable enterprise systems and leveraging <strong>Redis</strong> to solve complex concurrency challenges like <strong>distributed race conditions</strong>. My approach is rooted in strong engineering fundamentals, ensuring that every system I build is performant and maintainable.
                    <br/><br/>
                    I am at the forefront of <strong>Agentic Development</strong>, building sophisticated, AI-augmented workflows using tools like <strong>Claude Code</strong>, <strong>Co-worker</strong>, and <strong>Gemini CLI</strong>. I focus on the intersection where architectural integrity meets AI-driven efficiency to deliver robust, future-proof solutions.
                    <br/><br/>
                    Beyond core development, I have specialized experience in niche domains such as <strong>Post-Quantum Security</strong> with Crystals PQC and immersive <strong>VR development</strong> in Unity.
                </p>

                <br/>

                <a href={RESUME_URL} className="flex text-sm sm:text-xl/9 items-center gap-3 text-black bg-white hover:bg-white/70 p-2 rounded-sm hover:text-black mr-auto">
                    <FaFileDownload/>
                    Download resume
                </a>

                
            </div>
    </div>
    );
} 

export default HeroSection;